import { ApiResponseError } from '../ApiResponseError';
import { VeriffVerificationSession } from './model/VeriffVerificationSession';
import { VeriffSessionRequest } from './model/VeriffSessionRequest';

export const getVeriffVerificationSession = async (
  veriffVerificationTrigger: VeriffSessionRequest,
): Promise<VeriffVerificationSession> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(veriffVerificationTrigger),
    credentials: 'include',
  };

  const endpoint = `${process.env.VERIFF_SERVICE_BASE_URL}/api/session`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as VeriffVerificationSession;
};

export const getVeriffVerificationSessionLightRegisteredUser = async (
  veriffVerificationTrigger: VeriffSessionRequest,
  userId: string,
): Promise<VeriffVerificationSession> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${userId}`,
    },
    body: JSON.stringify(veriffVerificationTrigger),
    credentials: 'include',
  };

  const endpoint = `${process.env.VERIFF_SERVICE_BASE_URL}/light-user/api/session`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as VeriffVerificationSession;
};
